/**
 * Hide the header wishlist heart when the Swym wishlist app can't run.
 *
 * The heart (a.swym-header-launcher in sections/header.liquid) is plain theme markup
 * linking to /pages/wishlist, so it renders whether or not the app does. Swym itself only
 * boots when the visitor has allowed "preferences" cookies — its embed checks
 * Shopify.customerPrivacy.preferencesProcessingAllowed() and treats anything other than
 * `true` as no consent (Pandectes' "Functionality" category feeds that value). Without
 * it the heart leads to a wishlist page that never loads.
 *
 * This mirrors that same check onto <html> as a `wishlist-unavailable` class, which
 * src/scss/_wishlist.scss uses to hide the heart. A class on the root rather than a style
 * on the element so it survives the header section being re-rendered.
 *
 * The heart only needs consent to exist by the next page load (the wishlist page is a
 * full navigation), so it is shown again as soon as consent is granted — no reload needed.
 */

const root = document.documentElement;
const UNAVAILABLE_CLASS = 'wishlist-unavailable';

function wishlistAllowed() {
  const shopify = window.Shopify;

  // Swym always runs in the theme editor, regardless of consent.
  if (shopify && shopify.designMode) return true;

  const privacy = shopify && shopify.customerPrivacy;
  return !!privacy && typeof privacy.preferencesProcessingAllowed === 'function' && privacy.preferencesProcessingAllowed() === true;
}

function update() {
  root.classList.toggle(UNAVAILABLE_CLASS, !wishlistAllowed());
}

function init() {
  const shopify = window.Shopify;

  if (shopify && shopify.customerPrivacy) {
    update();
  } else if (shopify && typeof shopify.loadFeatures === 'function') {
    // The consent API is an async script, so it may not have arrived yet. Leave the heart
    // alone until it has, rather than hiding it and flashing it back in for everyone who
    // has already accepted. If it fails to load, Swym has no consent to read either.
    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1', onLoad: update }]);
  }

  // Fired by Shopify whenever consent is saved — which is how Pandectes records the
  // visitor's choice from its banner and preferences panel.
  document.addEventListener('visitorConsentCollected', update);
}

init();
